module.exports = __webpack_public_path__ + "img/1280.c49cafbb.svg";